import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
import React from "react";
var __jsx = React.createElement;
const LuggageIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: "29",
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M8.125 0C7.77982 0 7.5 0.279822 7.5 0.625V3.75H6.25C4.86929 3.75 3.75 4.86929 3.75 6.25V16.25C3.75 17.1915 4.27043 18.0114 5.0393 18.4378C5.01365 18.5376 5 18.6422 5 18.75C5 19.4404 5.55964 20 6.25 20C6.94036 20 7.5 19.4404 7.5 18.75H12.5C12.5 19.4404 13.0596 20 13.75 20C14.4404 20 15 19.4404 15 18.75C15 18.6422 14.9864 18.5376 14.9607 18.4378C15.7296 18.0114 16.25 17.1915 16.25 16.25V6.25C16.25 4.86929 15.1307 3.75 13.75 3.75H12.5V0.625C12.5 0.279822 12.2202 0 11.875 0H8.125ZM11.25 3.75H8.75V1.25H11.25V3.75ZM15 16.25C15 16.9404 14.4404 17.5 13.75 17.5H6.25C5.55964 17.5 5 16.9404 5 16.25V8.75H15V16.25ZM6.25 5H13.75C14.4404 5 15 5.55964 15 6.25V7.5H5V6.25C5 5.55964 5.55964 5 6.25 5Z",
    fill: color
  }));
};
export default LuggageIcon;